/* eslint-disable max-len */
module.exports = {
  // =================== Privacy ===================
  privacy: {
    head: "Политика конфиденциальности",
    datechange: "Дата последних изменений: 2022-12-30",
    blocks: [
      {
        title: "Введение",
        href: "#ref1",
        text: `
          Защита конфиденциальности данных пользователей веб-сайта smartteam.dev имеет первостепенное значение для нашей компании. 
          В настоящей политике конфиденциальности перечислены виды личной информации, получаемой и собираемой через веб-сайт smartteam.dev, a также содержатся сведения о том, как эти персональные данные используются.
        `
      },
      {
        title: "Личная информация, которую мы собираем",
        href: "#ref2",
        text: `
          Информация, которую мы собираем, делится на две категории:<br>
          1) Информация личного характера, которая включает данные, предоставляемые вами добровольно во время того, как вы: оформляете заказы, заполняете анкеты (например: формы обратной связи), регистрируетесь на сайте и указываете свой адрес электронной почты или телефон.<br>
          2) Деперсонифицированная информация, которая автоматически собирается при посещении пользователями нашего веб-сайта.
        `
      },
      {
        title: "Использование личной информации",
        href: "#ref3",
        text: `
          Сбор личной информации необходим для того, чтобы мы могли предоставлять запрашиваемые вами публикационные материалы и услуги или же выполнять конкретные уставные обязанности (или и то, и другое). 
          Конкретная цель сбора личной информации будет объяснена непосредственно при сборе данных или же станет очевидна, исходя из ситуации.
        `
      },
      {
        title: "Безопасность данных",
        href: "#ref4",
        text: `
          Будут приниматься разумные меры для обеспечения того, чтобы вся информация, собираемая, используемая или раскрываемая на веб-сайте smartteam.dev, являлась точной, полной, актуальной и хранилась в безопасном месте, доступ к которому был бы только у уполномоченных лиц. 
          Тем не менее мы не даем никаких гарантий в отношении взлома системы или любого несанкционированного доступа к данным со стороны третьих лиц.
        `
      },
      {
        title: "Файлы журнала",
        href: "#ref5",
        text: `
          Как и для многих других интернет-ресурсов, для работы веб-сайта smartteam.dev мы используем файлы журналов. 
          Файлы журналов содержат информацию об IP-адресах, типах интернет-браузеров, поставщиках интернет-услуг, времени и дате, страницах с внешними ссылками и страницах выхода, а также данные о количестве переходов. 
          Эта информация позволяет анализировать тенденции, управлять работой веб-сайта, отслеживать перемещения пользователей и собирать демографические сведения. 
          Данные об IP-адресах, включая любые другие сведения подобного характера, не имеют отношения к информации личного порядка.
        `
      },
      {
        title: "Веб-сайты третьих лиц",
        href: "#ref6",
        text: `
          Этот веб-сайт может содержать гиперссылки на веб-сайты третьих лиц. 
          Мы отказываемся от любой ответственности за содержание таких веб-сайтов, а также не несем ответственности за методы, к которым они прибегают для сбора, хранения, использования и распространения любой личной информации, предоставляемой пользователями. 
          При переходе на веб-сайты третьих лиц по гиперссылкам, указанным на этом веб-сайте, мы рекомендуем вам ознакомиться с положениями о конфиденциальности этих интернет-ресурсов для того, чтобы вы могли понять, каким образом предоставленная вами личная информация будет собираться, храниться, использоваться и распространяться.
        `
      },
      {
        title: "Изменения в политике конфиденциальности",
        href: "#ref7",
        text: `
          Мы оставляем за собой право по своему усмотрению обновлять или пересматривать настоящую политику конфиденциальности в любое время. 
          Изменения в политике конфиденциальности вступают в силу сразу же после их публикации на этом веб-сайте. 
          Регулярно просматривайте настоящую политику конфиденциальности для того, чтобы оставаться в курсе изменений и обновлений. 
          Если вы продолжите использовать этот веб-сайт и будете указывать свою личную информацию после публикации изменений в настоящей политике конфиденциальности, это будет означать принятие вами этих изменений.
        `
      },
      {
        title: "Политика в отношении файлов cookie",
        href: "#ref8",
        text: `
          <span class='txt-blue'>ВАЖНАЯ ИНФОРМАЦИЯ: ВНИМАТЕЛЬНО ПРОЧТИТЕ ПЕРЕД ИСПОЛЬЗОВАНИЕМ ЭТОГО ВЕБ-САЙТА.</span><br>
          Настоящая политика содержит пояснения по поводу использования файлов cookie на этом веб-сайте. 
          Положения настоящей политики могут пересматриваться время от времени. 
          В случае внесения каких-либо изменений мы сообщим вам об этом соответствующим образом, например, путем размещения пересмотренной политики на этой странице с указанием даты последнего обновления. 
          Используя данный веб-сайт, вы соглашаетесь с тем, что файлы cookie будут сохраняться на вашем компьютере в соответствии с условиями настоящей политики. 
          Если вы не хотите получать файлы cookie с этого веб-сайта, отключите их или воздержитесь от использования этого интернет-ресурса.
        `
      },
      {
        title: "Что такое файлы cookie?",
        href: "#ref9",
        text: `
          Файлы cookie — это небольшие текстовые фрагменты информации, передаваемые в интернет-браузер веб-сайтом и сохраняемые на жестком диске компьютера. 
          Эти файлы позволяют идентифицировать пользователей веб-сайта и фиксировать определенные данные, которые будут использованы при их следующем посещении. 
          Эти данные могут включать сведения о том, какие страницы вы посетили, что выбирали в меню, а также любую конкретную информацию, указанную в ходе заполнения форм, включая время и дату посещения.
        `
      },
      {
        title: "Типы файлов cookie",
        href: "#ref10",
        text: `
          <strong>Существует два основных типа файлов cookie:</strong><br>
          <strong>Сеансовые файлы cookie:</strong> это временные файлы, которые хранятся в памяти компьютера пользователя в течение сеанса интернет-браузера, то есть до тех пор, пока пользователь не покинул веб-сайт. 
          Сеансовые файлы cookie позволяют идентифицировать пользователя, который просматривает страницы веб-сайта в течение одного сеанса интернет-браузера и используются для более эффективной работы веб-сайта.<br>
          <strong>Постоянные файлы cookie:</strong> в отличие от сеансовых, постоянные файлы cookie хранятся в памяти компьютера до тех пор, пока не истечет их срок действия, или же пока файлы не будут удалены. 
          Они позволяют идентифицировать пользователей при последующих посещениях веб-сайта и запоминать информацию о пользовательских предпочтительных параметрах с целью, чтобы предоставляемые услуги соответствовали индивидуальным пожеланиям.
        `
      },
      {
        title: "Использование файлов cookie на этом веб-сайте",
        href: "#ref11",
        text: `
          В настоящее время на этом веб-сайте мы используем (и собираемся использовать в дальнейшем) перечисленные далее типы файлов cookie. <strong>Сеансовые файлы cookie используются для следующих целей:</strong><br>
          обеспечения безопасности и проверки данных пользователей во время использования и перехода по страницам веб-сайта. 
          Благодаря этому не нужно каждый раз вводить свои данные при первом посещении страницы.<br>
          <strong>Постоянные файлы cookie используются для следующих целей:</strong><br>
          идентификации пользователей при последующих посещениях веб-сайта, благодаря чему нет необходимости вводить данные несколько раз во время перемещения между страницами или службами нашего веб-сайта.
          Сбор и обобщение анонимных сводных данных с целью статистического учета и оценки для того, чтобы понять, каким образом пользователи используют веб-сайт и как его улучшить. 
          Многие файлы cookie предназначены для обеспечения оптимального использования веб-сайта. 
          Мы используем файлы cookie для того, чтобы повысить удобство работы с веб-сайтом (например, файлы cookie, которые позволяют определить, поддерживает ли интернет-браузер пользователя специфические технологические характеристики). 
          Это позволяет, например, увеличить скорость отображения страниц при запросах загрузки больших файлов. 
          В дополнение к файлам cookie, которые передают нам данные, мы используем файлы cookie, которые собирают информацию и отправляют ее третьим лицам. 
          Примером этого является Google Analytics. 
          Мы используем Google Analytics для сбора и обобщения информации, включая информацию о количестве посетителей веб-сайта, сведения о ресурсах, с которых был выполнен переход на наш веб-сайт, а также данные о просмотренных страницах. 
          Посетите веб-сайт Google для получения дополнительной информации о политике конфиденциальности Google и ознакомления с информацией о том, как избежать получения файлов cookie сервиса Google Analytics. 
          Как и в случае с файлами cookie, получаемыми с нашего веб-сайта, отключить функцию получения файлов cookie с интернет-ресурсов третьих лиц можно в настройках интернет-браузера. 
          Некоторые файлы cookie могут собирать и хранить личную информацию, например, имя или адрес электронной почты пользователя. 
          Мы обязуемся уважать и защищать ваше право на конфиденциальность и гарантируем, что вся собранная нами личная информация хранится и обрабатывается в соответствии с нашей политикой конфиденциальности.
        `
      },
      {
        title: "Отказ от получения файлов cookie при посещении этого веб-сайта",
        href: "#ref12",
        text: `
          В большинстве интернет-браузеров по умолчанию настроена функция получения файлов cookie. 
          Тем не менее при желании у пользователя есть возможность отключить файлы cookie, как правило, путем изменения настроек программы для работы в Интернете. 
          Кроме того, параметры интернет-браузера можно настроить таким образом, чтобы разрешать получение конкретных файлов cookie или получать уведомление каждый раз, когда новый файл cookie будет сохраняться в памяти компьютера. 
          Таким образом пользователь сможет принимать решение о получении или отклонении файлов cookie. 
          <strong>Пользователю доступны различные способы управления файлами cookie</strong>, например, можно воспользоваться разделом «Справка» в интернет-браузере. 
          Также можно отключить получение файлов веб-технологий, аналогичных файлам cookie (например, данные Local Shared Objects, также называемые Flash cookie), и удалить используемые ими сохраненные данные, изменив настройки дополнительных компонентов интернет-браузера или посетив веб-сайт его разработчика.
        `
      },
      {
        title: "Дополнительная информация",
        href: "#ref13",
        text: `Если у вас возникли какие-либо вопросы по поводу этой политики конфиденциальности, свяжитесь с нами по адресу mail@smartteam.dev`
      }
    ]
  }
};
/* eslint-enable max-len */
